import { ClientProfilePage } from './ClientProfilePage'
import { getClientPath } from './paths'

export const routes = [
  {
    path: getClientPath(':id'),
    component: ClientProfilePage,
    exact: true
  }
]
